import DataMapper from './DataMapper'
import CaseCountRM from '../responsemodel/CaseCountRM'
import CaseCount from '../../models/CaseCount'

class CaseCountDataMapper extends DataMapper<CaseCountRM, CaseCount> {
  map = (rm: CaseCountRM) => new CaseCount(rm.state, rm.totalCases, rm.casesWithInstructions, rm.cases)
}

export default CaseCountDataMapper
